export enum AnonymousRequestType {
  vConsult = "VCONSULT",
  vCI = "VCLINICALINFORMATICIST"
}
